import { render, staticRenderFns } from "./absentpermit.vue?vue&type=template&id=4328572e"
import script from "./absentpermit.vue?vue&type=script&lang=js"
export * from "./absentpermit.vue?vue&type=script&lang=js"
import style0 from "./absentpermit.vue?vue&type=style&index=0&id=4328572e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports